import { useParams } from "react-router-dom";
import { useRegisterAttendance } from "../../classes/api/registerAttendance";
import { useRegisterLiveAttendance } from "../api/registerLiveAttendance";
import { Button } from "@mui/material";
import { createNotification } from "../../../shared/store/notifications";
import { useLiveData } from "../api/getLiveData";

export default function RegisterLiveAttendancePage() {
  const registerLiveAttendanceMutation = useRegisterLiveAttendance();
  const registerClassAttendanceMutation = useRegisterAttendance();

  const params = useParams();

  const liveDataQuery = useLiveData({ liveId: params.liveId });

  const handleClick = () => {
    registerLiveAttendanceMutation.mutate(
      { liveId: params.liveId },
      {
        onSuccess: () => {
          createNotification({
            type: "success",
            message: "Presença registrada com sucesso",
          });
        },
      }
    );
  };
  return <></>;
}
